import React from "react";

import { SidebarItemsType } from "@/types/sidebar";
import SidebarNavList from "./SidebarNavList";
import { cn } from "@/utils/cn";

type SidebarNavSectionProps = {
  component?: React.ElementType;
  pages: SidebarItemsType[];
  title?: string;
  collapsed?: boolean;
};

function SidebarNavSection({
  title,
  pages,
  component: Component = "nav",
  collapsed = false,
}: SidebarNavSectionProps) {
  return (
    <Component>
      {title && (
        // Height/padding stay identical collapsed or not — only opacity toggles.
        // Collapsing this to h-0 used to remove ~60px of vertical space that's
        // present in the expanded layout, so every row below it (and its icon)
        // sat ~60px higher in the collapsed rail than its expanded counterpart.
        // Reserving the same space in both states keeps rows aligned when toggling.
        <p
          className={cn(
            "m-0 block px-6 pb-3 pt-[33.6px] text-[0.875rem] uppercase leading-none text-sidebar-color/60 transition-opacity duration-300",
            collapsed && "opacity-0"
          )}
          aria-hidden={collapsed}
        >
          {title}
        </p>
      )}
      <div className="flex flex-col gap-2">
        <SidebarNavList pages={pages} depth={0} collapsed={collapsed} />
      </div>
    </Component>
  );
}

export default SidebarNavSection;
